import type { Data } from './+data.server';

/** useData() is unreliable on the client in this app (see pages/salary/@role/parseSalaryRoleInitialScript.ts);
 *  the page embeds its +data payload in a script tag and reads it back from there. */
export const TAX_ICEBERG_PAGE_SCRIPT_ID = 'tax-iceberg-page-initial';

export function getTaxIcebergDataFromScript(): Data | undefined {
  if (typeof document === 'undefined') return undefined;
  const el = document.getElementById(TAX_ICEBERG_PAGE_SCRIPT_ID);
  if (!el || el.tagName !== 'SCRIPT') return undefined;
  try {
    const raw = (el as HTMLScriptElement).textContent?.trim() ?? '';
    const parsed = raw ? (JSON.parse(raw) as Data) : undefined;
    return parsed && typeof parsed === 'object' ? parsed : undefined;
  } catch {
    return undefined;
  }
}
